import { createPriceFormatter } from './formatter';
export const setPriceFormatter = priceFormatter => {
  window.etiPriceFormatter = priceFormatter;
};
export const getPriceFormatter = () => {
  return window.etiPriceFormatter !== undefined ? window.etiPriceFormatter : createPriceFormatter();
};
//# sourceMappingURL=provider.js.map